import React from "react";
import "./layout.scss";

const Footer = () => {
  return (
    <div className='bg-white footer-web'>
      <div className='container'>
        <div className='footer-wrapper text-center'>
          <a href='https://milyas.vercel.app/' className='text-secondary'>
            Muhammad Ilyas - Test Frontend Project Jubelio
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
